/**
 * Cache keys for projected option lists.
 *
 * React Query caches by key alone, so two pages that ask the same key for
 * different columns do not get different answers — they get whichever one ran
 * first. `["companies_lite"]` was shared by four call sites asking for four
 * different column lists, and `["client_groups_lite"]` by three. A page reading
 * `client_group_name` out of a cache some other page had filled with
 * `"id, legal_name"` saw `undefined` and rendered a blank, and which page you
 * had visited first decided whether it worked.
 *
 * `liteList` pairs the key with the projection that fills it, so the two cannot
 * drift: different column lists get different cache entries, and identical ones
 * still share a single request. Invalidation is unaffected — React Query matches
 * key prefixes, so `invalidateQueries({ queryKey: ["companies_lite"] })` still
 * reaches every projection of it.
 */

export interface LiteList {
  /** The cache key, carrying the projection. */
  key: readonly [string, string];
  /** The column list to pass to `.select(...)`. */
  columns: string;
}

export function liteList(name: string, columns: string): LiteList {
  return { key: [name, columns] as const, columns };
}
